import isEmpty from 'lodash/isEmpty';
import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordName } from 'vue-router';

import { ROUTES } from '@/consts/routes.const';
import { AppGetters } from '@/store/App/getters';
import { store } from '@store/index';

const noDataAllowdRoutes = [
  ROUTES.WELCOME.name,
  ROUTES.VALIDATE_BOOKING.name,
  ROUTES.REQUIRED_CLIENT_DATA.name,
  ROUTES.BOOKING_NOT_FOUND.name,
] as RouteRecordName[];

const defaultRouteName = ROUTES.WELCOME.name;

export function noDataNavigationGuard(to: RouteLocationNormalized) {
  if (!to.name) {
    return { name: defaultRouteName };
  }

  if (noDataAllowdRoutes.includes(to.name)) {
    return;
  }

  const { brokerId, token } = store.getters[AppGetters.GetBrokerData];
  if (!brokerId || !token) {
    return { name: defaultRouteName, query: to.query };
  }

  return;
}

function hasQueryParams(route: RouteLocationNormalized) {
  return !isEmpty(route.query);
}

export function keepNavigationGuardParams(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (to.name && !hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query });
  }
  next();
}
